import { useSelector } from 'react-redux';
import { createStateSelector } from '~/_shared/utils/memoize/createSelector';
import type { AppState } from '~/store/app.store';
import { aggregateSpreadsheetRowRelationsStatuses } from '~/store/rowRelations/rowRelations.helper';

const rowRelationsStateSelector = (state: AppState) => state.spreadsheet.rowRelations;
export const useRowRelationsState = () => useSelector(rowRelationsStateSelector);

const rowRelationsAggregateSelector = createStateSelector(
  rowRelationsStateSelector,
  aggregateSpreadsheetRowRelationsStatuses,
);

export const isRowRelationsBeingProcessedOrRequiredSelector = createStateSelector(
  rowRelationsAggregateSelector,
  rowRelationsAggregate => rowRelationsAggregate.required || rowRelationsAggregate.processing,
);
export const useIsRowRelationsBeingProcessedOrRequiredSelector = () =>
  useSelector(isRowRelationsBeingProcessedOrRequiredSelector);
